module.exports = __webpack_public_path__ + "static/media/galardao.ca588887.jpg";